import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQueryParams } from '../../../../../hooks/useQueryParams';
import { routes } from '../../../routes';
import { JobsFiltersKeys, JobsFiltersType } from '../types';
import Checkbox from '../../../components/Checkbox';

type Props = {
  id: JobsFiltersKeys;
  label: string;
  filterData: JobsFiltersType;
};

const JobsCheckboxFilter: React.FC<Props> = ({ id, label, filterData }) => {
  const history = useHistory();
  const queryParams = useQueryParams();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    history.push(
      routes.jobsList.route
        .withQueryParams({
          ...queryParams,
          [id]: e.target.checked ? 'true' : '',
        })
        .create({}),
    );
  };

  return (
    <Checkbox
      id={id}
      labelClassName="align-middle"
      label={label}
      checked={filterData[id] === 'true'}
      onChange={handleChange}
    />
  );
};

export default JobsCheckboxFilter;
